import React, { useMemo } from "react";

import { Grid, Skeleton, Typography } from "@mui/material";

import { InfoCard } from "components/admin/InfoCard";
import { BlockStandard } from "components/admin/BlockStandard";
import { formatInvoiceData } from "logic/InvoiceDetails";
import { InvoiceDetailCard } from "components/admin/InvoiceDetailCard";
import { useInvoiceDetailsContext } from "contexts/BillingContext";

export const InvoiceDetails = () => {
  const { isLoading, invoice, balance, client } = useInvoiceDetailsContext();
  const data = useMemo(
    () => formatInvoiceData(invoice, balance),
    [invoice, balance]
  );

  const displayClientBlock =
    client.clientName && client.supplierKey && client.taxNumber;

  return (
    <>
      <BlockStandard>
        <Grid container gap={1} sx={{ mt: 1 }}>
          <InfoCard
            loading={isLoading}
            title="Valor na Fatura"
            value={data.balance}
          />
          <InfoCard
            loading={isLoading}
            title="Vencimento"
            value={data.dueDate}
          />
        </Grid>
      </BlockStandard>
      {!isLoading && data.warnings.length !== 0 && (
        <BlockStandard title="Considerações sobre sua fatura">
          <Typography>Verifique com atenção os dados abaixo.</Typography>
          {data.warnings.map(({ title, description }) => (
            <InvoiceDetailCard
              variant="warning"
              key={title}
              title={title}
              meaning={description}
            />
          ))}
        </BlockStandard>
      )}
      {!isLoading && data.inconsistencies.length !== 0 && (
        <BlockStandard title="Dados Inconsistentes">
          <Typography>
            Significa que houve divergência entre os dados da fatura e o valor
            calculado.
          </Typography>
          {data.inconsistencies.map((item) => (
            <InvoiceDetailCard key={item.title} {...item} />
          ))}
        </BlockStandard>
      )}
      {!isLoading && data.consistencies.length !== 0 && (
        <BlockStandard title="Dados Consistentes">
          <Typography>
            Significa que não houve divergência entre os dados da fatura e o
            valor calculado.
          </Typography>
          {data.consistencies.map((item) => (
            <InvoiceDetailCard key={item.title} {...item} />
          ))}
        </BlockStandard>
      )}
      <BlockStandard
        title={displayClientBlock ? "Dados da Fatura" : ""}
        hideDivider
      >
        {displayClientBlock && (
          <Grid container direction="row" gap={2}>
            <Grid container direction="column" gap={2} sx={{ flex: 1 }}>
              <Grid container direction="column">
                <Typography variant="body2">Proprietário</Typography>
                <Typography>
                  {isLoading ? <Skeleton /> : client.clientName}
                </Typography>
              </Grid>
              <Grid container direction="column">
                <Typography variant="body2">Concessionária</Typography>
                <Typography>
                  {isLoading ? <Skeleton /> : client.supplierKey}
                </Typography>
              </Grid>
            </Grid>
            <Grid container direction="column" sx={{ flex: 1 }}>
              <Typography variant="body2">
                Identificação Fiscal (CPF/CNPJ)
              </Typography>
              <Typography>
                {isLoading ? <Skeleton /> : client.taxNumber}
              </Typography>
            </Grid>
          </Grid>
        )}

        <Typography variant="caption">
          Este relatório foi executado com base de dados recebidos pela
          concessionária de energia, plataforma de inversores e com a
          autorização do utilizador da propriedade da usina consumidora.
        </Typography>
      </BlockStandard>
    </>
  );
};
